import script from "./StatusMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusMessage.vue?vue&type=script&setup=true&lang=js"

import "./StatusMessage.vue?vue&type=style&index=0&id=a16d6654&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a16d6654"]])

export default __exports__